// frontend/src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';

// Importamos los estilos globales (Asegúrate de tener Tailwind configurado aquí o en App.css)
import './index.css';

import App from './App';

// Inicializamos el contenedor principal de React
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderizamos la aplicación dentro del StrictMode para identificar problemas en ciclo de vida
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);